export enum DownloadPdfScreen {
    DOWNLOAD_PDF_ERROR,
    DOWNLOAD_PDF_LOADING,
    DOWNLOAD_PDF_AVAILABLE,
    DOWNLOAD_PDF_TOO_MANY_COLUMNS,
}
